import * as React from "react";
import PasswordResetRequest from "@route-planner/components/PasswordResetRequest";

const Component = (props) => {
  return <PasswordResetRequest />;
};

const page = {
  routeProps: {
    path: "PasswordReset",
    component: Component,
  },
  name: "Password Reset",
  label: "Password Reset",
  title: "Password Reset",
  showOnMenu: false,
};

export default page;
